import Layout from "@/Layout";

/**
 * @title: 路由标题
 * @hidden：是否显示该菜单
 * @isFooter: 是否需要底部导航
 */
export default [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: "home",
    meta: {
      title: "layout",
      hidden: false,
    },
    children: [
      {
        path: "home",
        name: "home",
        component: () => {
          return import("@/views/home");
        },
        meta: {
          title: "首页",
          hidden: true,
          isFooter: true,
        },
      },
      {
        path: "/information",
        name: "/information",
        component: () => {
          return import("@/views/information");
        },
        meta: {
          title: "园区资讯",
          hidden: true,
          isFooter: true,
        },
      },
      {
        path: "enterprisePolicy",
        name: "enterprisePolicy",
        component: () => {
          return import("@/views/enterprisePolicy");
        },
        meta: {
          title: "惠企政策",
          hidden: true,
          isFooter: true,
        },
      },
      {
        path: "financeProduct",
        name: "financeProduct",
        component: () => {
          return import("@/views/financeProduct");
        },
        meta: {
          title: "金融产品",
          hidden: true,
          isFooter: true,
        },
      },
      {
        path: "/purchaseInfo",
        name: "/purchaseInfo",
        component: () => {
          return import("@/views/purchaseInfo");
        },
        meta: {
          title: "采购信息",
          hidden: true,
          isFooter: true,
        },
      },
      {
        path: "talents-bringIn",
        name: "talents-bringIn",
        component: () => {
          return import("@/views/talents-bringIn");
        },
        meta: {
          title: "人才服务",
          hidden: true,
          isFooter: true,
        },
      },
      {
        path: "job-details",
        name: "job-details",
        component: () => {
          return import("@/views/job-details");
        },
        meta: {
          title: "招聘详情",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "park-talent",
        name: "park-talent",
        component: () => {
          return import("@/views/park-talent");
        },
        meta: {
          title: "人才公寓",
          hidden: true,
          isFooter: true,
        },
      },
      // {
      //   path: "product-service",
      //   name: "product-service",
      //   component: () => {
      //     return import("@/views/product-service");
      //   },
      //   meta: {
      //     title: "园区招商",
      //     hidden: true,
      //     isFooter: true,
      //   },
      // },
      // {
      //   path: "visitor-make",
      //   name: "visitor-make",
      //   component: () => {
      //     return import("@/views/visitor-make");
      //   },
      //   meta: {
      //     title: "访客预约",
      //     hidden: true,
      //     isFooter: true,
      //   },
      // },
      // {
      //   path: "access-gardenArea",
      //   name: "access-gardenArea",
      //   component: () => {
      //     return import("@/views/access-gardenArea");
      //   },
      //   meta: {
      //     title: "进入园区",
      //     hidden: true,
      //     isFooter: true,
      //   },
      // },
      {
        path: "user-login",
        name: "user-login",
        component: () => {
          return import("@/views/user-login");
        },
        meta: {
          title: "用户登录",
          hidden: true,
          isFooter: false,
        },
      },
      {
        path: "resetPassword",
        name: "resetPassword",
        component: () => {
          return import("@/views/user-login/resetPassword.vue");
        },
        meta: {
          title: "忘记密码",
          hidden: false,
          isFooter: false,
        },
      },
      {
        path: "talent-info",
        name: "talent-info",
        component: () => {
          return import("@/views/talent-info");
        },
        meta: {
          title: "人才信息",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "talent-info-detail",
        name: "talent-info-detail",
        component: () => {
          return import("@/views/talent-info/detail");
        },
        meta: {
          title: "人才信息",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "park-details",
        name: "park-details",
        component: () => {
          return import("@/views/park-details");
        },
        meta: {
          title: "园区招商详情",
          hidden: false,
          isFooter: true,
        },
      },

      {
        path: "news-detail",
        name: "/info",
        component: () => {
          return import("@/views/news-detail");
        },
        meta: {
          title: "园区资讯详情",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "plant-rentOut",
        name: "plant-rentOut",
        component: () => {
          return import("@/views/plant-rentOut");
        },
        meta: {
          title: "园区招商",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "plant-details",
        name: "plant-details",
        component: () => {
          return import("@/views/plant-details");
        },
        meta: {
          title: "租售详情",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "policyProjectDetails",
        name: "policyProjectDetails",
        component: () => {
          return import("@/views/policyProject/detail");
        },
        meta: {
          title: "政策项目详情",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "policyDetails",
        name: "policyDetails",
        component: () => {
          return import("@/views/policyNotice/detail");
        },
        meta: {
          title: "政策公告详情",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "purchaseInfoDetails",
        name: "purchaseInfoDetails",
        component: () => {
          return import("@/views/purchaseInfo/detail");
        },
        meta: {
          title: "采购信息详情",
          hidden: false,
          isFooter: true,
        },
      },
      {
        path: "financeProductDetails",
        name: "financeProductDetails",
        component: () => {
          return import("@/views/financeProduct/detail");
        },
        meta: {
          title: "金融产品详情",
          hidden: false,
          isFooter: true,
        },
      },
    ],
  },
  {
    path: "*",
    name: "404",
    component: () => import("@/views/error/404.vue"),
    meta: {
      title: "404",
      hidden: false,
    },
  },
];
